<template>
  <v-layout column>
    <vbt-search
      v-model="searchData"
      :items="searchFieldsConfig"
      @reset="onResetSearch"
      @search="onSearch"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <template #toolbar>
        <v-btn
          small
          color="success"
          @click="openEditorDialog()"
        >
          Create box type
        </v-btn>
      </template>
      <vbt-table
        :items="boxTypes"
        :headers="headers"
        show-edit-action
        @click:edit="openEditorDialog"
      >
        <template #boxType="{ item: { boxType } }">
          {{ boxType }}
        </template>
        <template #inDimensions="{ item }">
          <v-layout>
            width: {{ item.innerWidth }};
            height: {{ item.innerHeight }};
            length: {{ item.innerLength }}
          </v-layout>
        </template>
        <template #outDimensions="{ item }">
          <v-layout>
            width: {{ item.outerWidth }};
            height: {{ item.outerHeight }};
            length: {{ item.outerLength }}
          </v-layout>
        </template>
        <template #shippingBox="{ item: { shippingBox } }">
          <kernel-status-badge
            v-if="typeof shippingBox === 'boolean'"
            :status="shippingBox ? 1 : 2"
            activity
          >
            {{ shippingBox ? 'Yes' : 'No' }}
          </kernel-status-badge>
          <span v-else>
            -
          </span>
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
        :total-count="boxTypesTotalCount"
      />
    </vbt-content-box>

    <kernel-box-type-editor
      v-model="editorDialog"
      :creator="isEditorCreateMode"
      :item="editableBox"
      @success="$_fetchData"
    />
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import {
  useEditorWithDialog,
  useDataLoading,
  usePagination,
  useSearch,
} from '@mixins/factories';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as BoxTypesNamespace, ActionTypes as BoxTypesActionTypes } from '../store.types';

import KernelBoxTypeEditor from '../_components/KernelBoxTypeEditor.vue';

const dataLoadingOptions = { getterName: BoxTypesActionTypes.GET_BOX_TYPES, contentName: 'boxTypes' };
const paginationOptions = { contentName: 'boxTypes' };
const searchOptions = {
  initialSearchDataStates: [
    'boxType', 'shipping',
  ],
  customTypes: {
    shipping: 'booleanString',
  },
};

const headers = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Box Type', value: 'boxType' },
  { text: 'Inner Dimensions', value: 'inDimensions' },
  { text: 'Outer Dimensions', value: 'outDimensions' },
  { text: 'Shipping Box', value: 'shippingBox' },
  { text: 'Size Units', value: 'sizeUnits' },
]);

export default {
  name: 'KernelBoxTypes',
  components: {
    KernelBoxTypeEditor,
  },
  mixins: [
    useEditorWithDialog({ editableItemName: 'editableBox' }),
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(BoxTypesNamespace, ['boxTypes', 'boxTypesTotalCount']),
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapState(EnumsNamespace, {
      boxTypesOptions: ({ enums: { boxType: enums } }) => (enums || [])
        .map(({ value }) => value),
    }),
    searchFieldsConfig() {
      return [
        {
          value: 'boxType',
          items: this.boxTypesOptions,
          label: 'Box Type',
          type: 'select',
        },
        {
          value: 'shipping',
          items: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
          label: 'Shipping',
          type: 'select',
        },
      ];
    },
  },
  watch: {
    suffix: '$_refreshData',
  },
  methods: {
    ...mapActions(BoxTypesNamespace, [BoxTypesActionTypes.GET_BOX_TYPES]),
  },
};
</script>
